"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = PageSection;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _cta = _interopRequireDefault(require("../cta/cta"));
var _pageSectionModule = _interopRequireDefault(require("./pageSection.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function PageSection(props) {
  var id = props.id,
    className = props.className,
    innerContainerClassName = props.innerContainerClassName,
    backgroundColour = props.backgroundColour,
    textColour = props.textColour,
    title = props.title,
    copy = props.copy,
    eyebrow = props.eyebrow,
    children = props.children;
  var sectionStyle = {
    '--backgroundColour': backgroundColour,
    '--textColour': textColour
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("section", {
    className: (0, _classnames["default"])(_pageSectionModule["default"].pageSection, className),
    style: sectionStyle,
    "data-testid": props['data-testid'],
    "data-section": title,
    id: id,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: (0, _classnames["default"])(_pageSectionModule["default"].innerContainer, innerContainerClassName),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: _pageSectionModule["default"].text,
        children: [eyebrow && /*#__PURE__*/(0, _jsxRuntime.jsx)("h2", {
          className: _pageSectionModule["default"].eyebrow,
          children: eyebrow
        }), title && /*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
          className: _pageSectionModule["default"].title,
          children: title
        }), copy && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: _pageSectionModule["default"].copy,
          children: copy
        })]
      }), children, props.cta && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: _pageSectionModule["default"].ctaWrapper,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_cta["default"], {
          type: props.cta.type,
          label: props.cta.label,
          target: props.cta.target
        })
      })]
    })
  });
}